import { useEffect, useState } from 'react';
import { EmployerJobListing } from 'util/resources';
import { EmployerJobListingResource } from 'util/resources/EmployerJobListing';
import { Collection } from 'active-resource';
import { QueryProps } from 'util/resources/APILibrary';

export const useEmployerJobListings = (
  initialQueryProps: QueryProps = {},
): {
  jobs: EmployerJobListingResource[];
  error: Error;
  loading: boolean;
  fetchJobs: (queryProps?: QueryProps) => Promise<void>;
  refreshJobs: () => Promise<void>;
} => {
  const [jobs, setJobs] = useState<EmployerJobListingResource[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error>(null);

  const fetchJobs = async (queryProps?: QueryProps) => {
    const { includes, select, where } = queryProps || initialQueryProps;

    setLoading(true);
    await EmployerJobListing.includes(...(includes || []))
      .select(...(select || []))
      .where(where)
      .all()
      .then((response: Collection<EmployerJobListingResource>) => {
        setLoading(false);
        setJobs(response.toArray());
      })
      .catch((error: Error) => {
        setLoading(false);
        setError(error);
      });
  };

  const refreshJobs = async () => {
    await fetchJobs();
  };

  useEffect(() => {
    void fetchJobs();
  }, []);

  return { jobs, error, loading, fetchJobs, refreshJobs };
};
